export default Object.freeze({
  inventoryAddressabilityRate: 'Addressability',
  bids: 'Bid Requests',
  bidResponses: 'Bid Responses',
  bidWons: 'Bids Won',
  companionSum: 'Companion Impressions',
  supplyDataCostInUSD: 'Data Cost',
  fillRate: 'Fill Rate',
  inventoryGdprRate: 'GDPR',
  supplyGrossClearingPriceSum: 'Gross Revenue',
  supplyGrossECPMInUSD: 'Gross eCPM',
  inventoryIdentifiabilityRate: 'Identifiability',
  objectiveCountableSum: 'Impressions',
  supplyInsertionRate: 'Insertion Rate',
  inventory: 'Inventory',
  ltr: 'LTR',
  supplyRevenueInUSD: 'Net Revenue',
  quartile0Sum: 'Quartile 0',
  quartile100Sum: 'Quartile 100',
  quartile25Sum: 'Quartile 25',
  quartile50Sum: 'Quartile 50',
  quartile75Sum: 'Quartile 75',
  supplyPlatformFeeInUSD: 'Supply Platform Fee',
  listenerIdHLL: 'Total Reach - Unique Users',
  winRate: 'Win Rate',
  supplyECPMInUSD: 'eCPM'
});
